<template>
  <div class="g_panel email" :class="{'darkmode': darkMode}" >
    <!-- header -->
    <div class="header g_panel-header">
      <span class="back icon-back" role="button" aria-label="back" tabindex="0" @click.stop="backHandler()" />
      <h1 class="title">
        Email
      </h1>
    </div>
    <!-- end header -->
    <div class="email-con">
      <div class="send" v-if="!hasSend">
        <div class="text" v-if="user.email && !change">{{user.email}}</div>
        <input type="text" v-else v-model="email" class="input" :placeholder="$t('emailPanel.placeholder')">
        <btn class="btn" v-if="!change && user.email" :loading="loading" @click.native="change = true" :label="user.email ? `${$t('emailPanel.editBtn')}` : `${$t('emailPanel.verifyBtn')}`"></btn>
        <btn class="btn" v-else :loading="loading" @click.native="sendEmail" :label="$t('emailPanel.verifyBtn')"></btn>
        <btn class="btn btn_cancel" v-if="change && user.email" @click.native="change = false" :label="$t('emailPanel.cancelBtn')"></btn>
      </div>
      <div class="tip" v-else>
        <div class="text">{{$t('emailPanel.sendTip')}} {{email}}</div>
        <div class="btn" @click="reSend">{{$t('emailPanel.reSendTip')}}</div>
        <div class="btn btn_2" @click="update">{{$t('emailPanel.varifyUpdate')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
import btn from '@/components/Btn'

export default {
  components: {
    btn,
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
    }),
  },
  watch: {
    show(val) {
      console.log(val)
    },
  },
  mounted() {
    this.$on('show', () => { this.show = true })
  },
  data() {
    return {
      email: '',
      loading: false,
      hasSend: false,
      change: false,
    }
  },
  methods: {
    ...mapMutations({
      togglePanel: 'email/togglePanel',
    }),
    ...mapActions({
      updateUserInfo: 'user/updateUserInfo',
    }),
    backHandler() {
      this.$router.back()
    },
    reSend() {
      this.hasSend = false
      this.email = ''
    },
    update() {
      this.updateUserInfo().then(() => {
        this.$toast({
          msg: this.$i18n.t('emailPanel.updateSucc'),
        })
      })
    },
    sendEmail() {
      if (this.loading) return
      if (!this.email || !/^[\w-.]+@([\w-]+\.)+[\w-]+$/ig.test(this.email)) {
        this.$toast({
          msg: this.$i18n.t('emailPanel.emailVarifyErr'),
        })
      } else {
        this.loading = true
        this.$http.post('/user/email', {
          email: this.email,
        }).then(() => {
          this.$toast({
            msg: this.$i18n.t('emailPanel.emailReqSuccTip'),
          })
          this.hasSend = true
        }).finally(() => {
          this.loading = false
        })
      }
    },
  },
}
</script>

<style lang="scss" scope>
.email-con{
  padding: 80px 22px 0;
  .send{
    display: flex;
    justify-content: center;
    flex-direction: column;
    .text{
      font-size: 16px;
      color: #AAAAAA;
      text-align: center;
      margin-bottom: 24px;
    }
    .input{
      background: #FFFFFF;
      border: 1px solid #E5E5E5;
      border-radius: 8px;
      margin:0 auto 24px;
      box-sizing: border-box;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 14px;
      width: 240px;
      &:focus{
        border: 1px solid #5094FF;
        outline: none;
      }
    }
    .btn{
      background-image: linear-gradient(180deg, #2E7FFF 0%, #2076FF 100%);
      border-radius: 19px;
      line-height: 32px;
      height: 32px;
      color: #fff;
      display: block;
      width: 240px;
      margin:0 auto 12px;
      font-size: 14px;
      box-shadow: 0 0 2px 0 rgba(135,135,135,0.20);
      &:hover{
        background-image: linear-gradient(180deg, #2772E9 0%, #216BE0 100%);
      }
    }
    .btn_cancel{
      color: #7B7B7B;
      background: #FFFFFF;
      border: 1px solid rgba(196,196,196,0.3);
      color: #3e3e3e;
      // background-image: linear-gradient(180deg, #FFFFFF 0%, #F5F5F5 98%);
      &:hover{
        background-image: linear-gradient(180deg, #FFFFFF 0%, #fcfcfc 98%);
      }
    }
  }
  .tip{
    text-align: center;
    font-size: 14px;
    padding-top: 6px;
    .text{
      color: #AAAAAA;
      line-height: 20px;
      margin-bottom: 8px;
    }
    .btn{
      color: #3483FF;
      line-height: 20px;
      margin-top: 10px;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
    .btn_2{
      margin-top: 10px;
    }
  }
}
</style>
